import axios from 'axios'
import baseService from './baseService'

const squareService = {
  async pay (payRequest) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios({
          url: process.env.VUE_APP_GATEWAY_PUBLIC_API + 'gateway/square/pay',
          method: 'POST',
          responseType: 'json',
          data: payRequest,
          withCredentials: false
        }).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response)
        })
      }
    })
  },
  async getLocations (dealerId) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios({
          url: process.env.VUE_APP_GATEWAY_PUBLIC_API + 'gateway/square/listlocations?dealerId=' + dealerId,
          method: 'POST',
          responseType: 'json',
          withCredentials: false
        }).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response)
        })
      }
    })
  },
  async getCustomers (dealerId) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios({
          url: process.env.VUE_APP_GATEWAY_PUBLIC_API + 'gateway/square/listCustomers?dealerId=' + dealerId,
          method: 'POST',
          responseType: 'json',
          withCredentials: false
        }).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response)
        })
      }
    })
  },
  async verifyPayer (payRequest) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios({
          url: process.env.VUE_APP_GATEWAY_PUBLIC_API + 'gateway/square/verifypayer',
          method: 'POST',
          responseType: 'json',
          data: payRequest,
          withCredentials: false
        }).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response)
        })
      }
    })
  },
  async processPayment (payRequest) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios({
          url: process.env.VUE_APP_GATEWAY_PUBLIC_API + 'gateway/square/processpayment',
          method: 'POST',
          responseType: 'json',
          data: payRequest,
          withCredentials: false
        }).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response)
        })
      }
    })
  },
  async syncPayment (payRequest) {
    return new Promise((resolve, reject) => {
      if (!baseService.isTestMode) {
        axios({
          url: process.env.VUE_APP_GATEWAY_PUBLIC_API + 'gateway/square/syncpayment',
          method: 'POST',
          responseType: 'json',
          data: payRequest,
          withCredentials: false
        }).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error.response)
        })
      }
    })
  }
}

export default squareService
